module.exports = __webpack_public_path__ + "img/alinotec_cameras.29bc7b84.webp";